import React from 'react';
import PropTypes from "prop-types";
import {toDangerouslySetHtml} from "../layout/toDangerouslySetHtml";

const ButtonMock = ({ name, label, btnClass }) => {
    return (
        <span id={name} className={"button-mock "  + btnClass} dangerouslySetInnerHTML={toDangerouslySetHtml(label)}></span>  //eslint-disable-line react/no-danger
    );
};

ButtonMock.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    btnClass: PropTypes.string
};

ButtonMock.defaultProps = {
    btnClass: "",
    disabled: false
};

export default ButtonMock;
